var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactUs2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3581_3490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3575 36.3581V78.8658C83.3575 84.6159 78.6789 89.2944 72.9288 89.2944H53.7147L41.6787 97.6897L26.9238 107.983V89.2944H10.4286C4.67855 89.2944 0 84.6159 0 78.8658V36.3581C0 30.6059 4.67855 25.9294 10.4286 25.9294H72.9288C78.6789 25.9294 83.3575 30.6059 83.3575 36.3581Z",
    fill: "#F5D34F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3584 36.3581V78.8658C83.3584 84.6159 78.6799 89.2945 72.9298 89.2945H53.7157L41.6797 97.6897V25.9294H72.9298C78.6799 25.9294 83.3584 30.6059 83.3584 36.3581Z",
    fill: "#FFA320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.632 13.8196L63.9795 55.4724L52.0547 55.9631L52.5453 44.0383L94.1981 2.38567C97.3556 -0.77182 102.476 -0.773296 105.634 2.3842C107.212 3.9622 108.002 6.03254 108.001 8.10118C108.001 10.1715 107.21 12.2416 105.632 13.8196Z",
    fill: "#619CED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5156 42.1504H41.6778V48.4785H14.5156V42.1504Z",
    fill: "#FFA320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5156 54.4332H41.6778V60.7612H14.5156V54.4332Z",
    fill: "#FFA320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5156 66.7159H68.6944V73.044H14.5156V66.7159Z",
    fill: "#FFA320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.632 13.8196L63.9795 55.4724L52.0547 55.9631L105.634 2.3842C107.212 3.96221 108.002 6.03254 108.001 8.10118C108.001 10.1715 107.21 12.2416 105.632 13.8196Z",
    fill: "#4773CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7493 52.7026L63.9795 55.4724L52.0547 55.9633L52.5453 44.0383L55.3151 41.2685L66.7493 52.7026Z",
    fill: "#514C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7493 52.7026L63.9795 55.4724L52.0547 55.9633L61.0321 46.9857L66.7493 52.7026Z",
    fill: "#2D2F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6797 66.7159H68.6963V73.044H41.6797V66.7159Z",
    fill: "#F78002"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3581_3490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs2);
export default __webpack_public_path__ + "static/media/ContactUs_2.f38b3964153eb484d43e76848771d0c1.svg";
export { ForwardRef as ReactComponent };